import React, { useState } from 'react';
import { ChevronDown, Shield, CheckCircle, XCircle, Mail, CreditCard } from 'lucide-react';
import { CartItem, ShoppingCart } from '../comp/ShoppingCart'
import Cookies from 'js-cookie'
import { catalogClient } from '../services/grpc'
import * as pb from '../generated/catalog_pb';
import { NewHeader } from '../comp/NewHeader'
import { Footer } from '../comp/Footer';
import { Input } from "../comp/ui/input";
import { Textarea } from "../comp/ui/textarea";
import { Label } from "../comp/ui/label";
import { Button } from "../comp/ui/button";
interface PolicySection {
  number: number;
  title: string;
  icon: React.ReactNode;
  content: string | string[];
  isNegative?: boolean;
}

export function WarrantyPolicy() {
    const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });
   const [isCartOpen, setIsCartOpen] = useState(false)
 const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [cartItemCount, setCartItemCount]= useState(0);
  const [customerName, setCustomerName] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');

  const [isAccountOpen, setIsAccountOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const initializeApp = async () => {
    let isguid = Cookies.get('guid');
    if (typeof isguid != 'string') {
      const req= new pb.guidReq();  
     
      req.setIp(window.location.hostname);
      catalogClient.getGuid(req, {}, (err, response) => {
        if (err) {
          console.error('Error fetching guid:', err.code, err.message);
        } else {
          Cookies.set('guid', response.getGuid());
        }
      });
    }
    const guid = Cookies.get('guid');
   
    };
    const updateQuantity = (porodId: number, quantity: number,storage:string) => {
          try {
            if (quantity === 0) {
              removeFromCart(porodId,storage)
              return
            }
            const guid = Cookies.get('guid');
            if (typeof guid === 'string') {
              const req = new pb.CartAddReq();
              req.setGuid(guid);
              req.setProductId(porodId);
              req.setQty(quantity);
              req.setStorage(storage);
              catalogClient.cartUpdate(req, {}, (err, response) => {
                if (err) {
                  console.error('Error adding to cart:', err.code, err.message);
                }
              });
            }
            setCartItems(prev => {
              const safeCartItems = prev || []
              return safeCartItems.map(item =>
                item.product.id === porodId  && item.storage === storage? { ...item, quantity,storage } : item
              )
            })
          } catch (error) {
            console.error('Error updating quantity:', error)
          }
        }
       
        const removeFromCart = (porodId: number,storage:string) => {
          try {
            const guid = Cookies.get('guid');
            if (typeof guid === 'string') {
            const req = new pb.CartRemoveReq();
            req.setGuid(guid);
            req.setProductId(porodId);
            req.setQty(0);
            req.setStorage(storage);
            catalogClient.cartRemove(req, {}, (err, response) => {
              
              if (err) {
                console.error('Error removing from cart:', err.code, err.message);
              }
            });
          }
            setCartItems(prev => {
              const safeCartItems = prev || []
              return safeCartItems.filter(item => !(item.product.id === porodId && item.storage === storage))
            })
          } catch (error) {
            console.error('Error removing from cart:', error)
          }
        }
        
          const setOrder = ()=>{
              if (!customerName || !customerPhone) {
                setAlertMessage(`Пожалуйста. Введите Ваше имя и номер телефона для связи`);
                return;
            }
          
              const guid = Cookies.get('guid');
              if (typeof guid === 'string') {
                const req=new pb.OrderAcceptReq();
                req.setGuid(guid);
                req.setName(customerName);
                req.setPhone(customerPhone);
                catalogClient.orderAccept(req, {}, (err, response) => {
                  if (err) {
                    console.error('Error removing from cart:', err.code, err.message);
                  } else {
                  if (response.getStatus()=="fail") { 
                    setAlertMessage(`${response.getMessage()}`);
                  } else {
                    setAlertMessage(`Спасибо за заказ.\n\ 
                      В ближайшее время наш менеджер свяжется с Вами.\n\ 
                      Номер вашего заказа: ${response.getNum()}`);
                    setCartItems([]);
                    setIsCartOpen(false);
                  }
                    return;
                  }
                });
              }
            }
          const OnsetIsInCartStorage=(items:string[])=>{
 
  }
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const [expandedSection, setExpandedSection] = useState<number | null>(1);
 const [messageModal, setMessageModal] = useState<{
  open: boolean;
  type: "success" | "error";
  text: string;
}>({
  open: false,
  type: "success",
  text: ""
});
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
     const req= new pb.MsqReq();
    req.setEmail(formData.email);
    req.setName(formData.name);
    req.setPhone(formData.phone);
    req.setTxt(formData.message);
   catalogClient.sendMsg(req, {}, (err, response) => {
      if (err) {
        console.error('Error fetching guid:', err.code, err.message);
      } else {
           setMessageModal({
      open: true,
      type: "success",
      text: "Ваше сообщение отправлено ✅"
      });
      }
    });    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: ""
    });
  };
  const sections: PolicySection[] = [
    {
      number: 1,
      title: "Общие условия",
      icon: <Shield className="w-6 h-6" />,
      content: [
        "На запчасти распространяется официальная гарантия производителя",
        "Срок до 12 месяцев",
        "Гарантия действует на всей территории РФ"
      ]
    },
    {
      number: 2,
      title: "Что покрывает гарантия",
      icon: <CheckCircle className="w-6 h-6" />,
      content: [
        "Заводской брак комплектующих и сборки",
        "Бесплатный обмен на аналогичный товар"
      ]
    },
    {
      number: 3,
      title: "Что не считается гарантийным",
      icon: <XCircle className="w-6 h-6" />,
      content: [
        "Механические повреждения, следы вскрытия, перегрева, попадания влаги",
        "Нарушение правил эксплуатации, хранения, подключения",
        "Естественный износ расходников (фильтры, лампы, батареи, пр.)",
        "Доработки, произведённые без согласования с нами"
      ],
      isNegative: true
    },
    {
      number: 4,
      title: "Как воспользоваться гарантией",
      icon: <Mail className="w-6 h-6" />,
      content: [
        "Напишите вашему менеджеру",
        "Прикрепите фото/видео неисправности, номер заказа и серийный номер изделия",
        "Мы принимаем товар любой ТК",
        "Средний срок рассмотрения — 3 рабочих дня"
      ]
    },
    {
      number: 5,
      title: "Возврат денег",
      icon: <CreditCard className="w-6 h-6" />,
      content: [
        "Если восстановить или заменить товар невозможно, мы возвращаем 100 % стоимости",
        "Возврат на ту же карту или расчётный счёт",
        "Срок возврата — 3 дня после принятия решения"
      ]
    }
  ];

  const toggleSection = (number: number) => {
    setExpandedSection(expandedSection === number ? null : number);
  };

  return (
      <div className="min-h-screen bg-gray-50">
        <NewHeader
           cartItemCount={cartItemCount}
           onCartClick={() => setIsCartOpen(true)}
           onAccountClick={() => setIsAccountOpen(true)}
           searchQuery={searchQuery}
           onSearchChange={setSearchQuery}
           page='policy'
         />
    <div className="w-full bg-gradient-to-br from-gray-50 to-white py-12 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">
            Гарантия и условия возврата
          </h1>
          <p className="text-gray-600">
            Полная информация о гарантийных обязательствах и политике возврата
          </p>
        </div>

        {/* Sections */}
        <div className="space-y-3">
          {sections.map((section) => (
            <div
              key={section.number}
              className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 bg-white"
            >
              {/* Header */}
              <button
                onClick={() => toggleSection(section.number)}
                className={`w-full px-6 py-5 flex items-center justify-between transition-colors ${
                  expandedSection === section.number
                    ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white'
                    : section.isNegative
                    ? 'bg-gradient-to-r from-red-50 to-orange-50 hover:from-red-100 hover:to-orange-100'
                    : 'bg-gradient-to-r from-blue-50 to-blue-100 hover:from-blue-100 hover:to-blue-150'
                }`}
              >
                <div className="flex items-center space-x-4 flex-1">
                  <div className={`${
                    expandedSection === section.number 
                      ? 'text-white' 
                      : section.isNegative 
                      ? 'text-red-600' 
                      : 'text-blue-600'
                  }`}>
                    {section.icon}
                  </div>
                  <h3 className={`text-lg font-bold text-left ${
                    expandedSection === section.number 
                      ? 'text-white' 
                      : 'text-gray-900'
                  }`}>
                    {section.number}. {section.title}
                  </h3>
                </div>
                <ChevronDown
                  className={`w-5 h-5 transition-transform flex-shrink-0 ml-4 ${
                    expandedSection === section.number ? 'rotate-180' : ''
                  } ${expandedSection === section.number ? 'text-white' : 'text-gray-600'}`}
                />
              </button>

              {/* Content */}
              {expandedSection === section.number && (
                <div className={`px-6 py-6 border-t ${
                  expandedSection === section.number
                    ? 'border-blue-200 bg-blue-50'
                    : 'border-gray-200 bg-white'
                }`}>
                  {Array.isArray(section.content) ? (
                    <ul className="space-y-3">
                      {section.content.map((item, index) => (
                        <li key={index} className="flex items-start space-x-3">
                          <span className={`font-bold mt-1 flex-shrink-0 ${
                            section.isNegative ? 'text-red-500' : 'text-blue-600'
                          }`}>
                            {section.isNegative ? '✕' : '✓'}
                          </span>
                          <span className="text-gray-700 leading-relaxed">
                            {item}
                          </span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-gray-700 leading-relaxed">
                      {section.content}
                    </p>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Contact Section */}
        <div className="mt-12 bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg p-8 text-white">
          <div className="flex items-start space-x-4">
            <Mail className="w-8 h-8 flex-shrink-0 mt-1" />
            <div className="flex-1">
              <h4 className="text-2xl font-bold mb-2">
                Остались вопросы?
              </h4>
              <p className="text-blue-100 mb-4">
                Наш менеджер поможет вам разобраться во всех нюансах гарантии и оформит возврат денежных средств при необходимости.
              </p>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <Label htmlFor="name">Ваше имя:*</Label>
                <Input
                  id="name"
                  name="name"
                  type="text"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  placeholder=""
                  className="mt-1"
                />
              </div>

              <div>
                <Label htmlFor="email">Email: *</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="john@example.com"
                  className="mt-1"
                />
              </div>

              <div>
                <Label htmlFor="phone">Телефон</Label>
                <Input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="(555) 123-4567"
                  className="mt-1"
                />
              </div>

              <div>
                <Label htmlFor="subject">Тема:*</Label>
                <Input
                  id="subject"
                  name="subject"
                  type="text"
                  required
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder=""
                  className="mt-1"
                />
              </div>

              <div>
                <Label htmlFor="message">Сообщение: *</Label>
                <Textarea
                  id="message"
                  name="message"
                  required
                  value={formData.message}
                  onChange={handleChange}
                  placeholder=""
                  rows={6}
                  className="mt-1"
                />
              </div>

              <Button 
                type="submit" 
                className="w-full bg-blue-600 hover:bg-blue-700"
              >
                Отравить
              </Button>
            </form>
            </div>
          </div>
        </div>

        {/* Footer Note */}
        <div className="mt-8 text-center text-sm text-gray-500">
          <p>
            Все условия гарантии и возврата подробно описаны выше.
            <br />
            Для более детального обсуждения вашего случая обратитесь к менеджеру.
          </p>
        </div>
      </div>
    </div>
     <Footer/>
       {Array.isArray(cartItems) && (
                    <ShoppingCart
                      isOpen={isCartOpen}
                      onOpenChange={setIsCartOpen}
                      cartItems={cartItems}
                      onUpdateQuantity={updateQuantity}
                      onRemoveItem={removeFromCart}
                      onOrder={setOrder}
                      customerName={customerName}
                      customerPhone={customerPhone}
                      setCustomerName={setCustomerName}
                      setCustomerPhone={setCustomerPhone}
                      setCartItemCount={setCartItemCount}
                      setIsInCartStorage={OnsetIsInCartStorage}
                    />
                  )}
       {messageModal.open && (
  <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
    <div className="bg-white rounded-xl shadow-xl p-6 w-[400px] text-center">
      <h2 className={`text-xl font-bold mb-4 ${
        messageModal.type === "success" 
          ? "text-green-600" 
          : "text-red-600"
      }`}>
        {messageModal.type === "success" ? "Отправленно" : "Ошибка"}
      </h2>

      <p className="text-gray-700 mb-6">
        {messageModal.text}
      </p>

      <button
        onClick={() => setMessageModal(prev => ({ ...prev, open: false }))}
        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
      >
        Закрыть
      </button>
    </div>
  </div>
)}
  </div>
  );
}

export default WarrantyPolicy;